import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Table, Affix, Input, Tag } from 'antd';
import _ from 'lodash';

export class UserAdd extends Component {
  static propTypes = {
    users: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    addUser: PropTypes.func.isRequired
  };

  state = {
    search: null
  }

  render() {
    const users = JSON.parse(JSON.stringify(this.props.users));

    return (
      <Affix offsetTop={0}>
        <div style={{marginTop:'50px'}}>
          <Row style={{ margin: '20px 0' }}>
            <Row gutter={16}>
              <Col span={24}>
                <Input
                  placeholder="Rechercher un utilisateur"
                  value={this.state.search}
                  onChange={(e) => this.setState({ search: e.target.value.toLowerCase() })}
                />
              </Col>
            </Row>
          </Row>
          <Row style={{ margin: '30px 0 0 0x' }}>
            <Table
              loading={{ size: "small", spinning: this.props.loading || this.props.adding}}
              onRow={(record) => ({
                  onClick: () => this.props.addUser(record),
                  style: {cursor: 'pointer'}
                })
              }
              pagination={{
                defaultPageSize: 20
              }}
              columns={[{
                title: 'Nom',
                dataIndex: 'lastName',
              }, {
                title: 'Prénom',
                dataIndex: 'firstName',
              }, {
                title: 'Classe',
                render: (i, record) => {
                  return (<Tag>{record.promotion.name}</Tag>)
                },
              }, {
                title: 'Inscrit',
                render: (i, record) => {
                  return typeof(this.props.inscriptions.find(item => item.user.id === record.id)) !== 'undefined' ? 
                    (<Tag color="green">Oui</Tag>) : (<Tag>Non</Tag>)
                },
              }]}
              dataSource={ _.sortBy(users, ['lastName']).filter(u =>
                (!this.state.search ||
                u.lastName.toLowerCase().includes(this.state.search.toLowerCase())
                || u.firstName.toLowerCase().includes(this.state.search.toLowerCase())
                || u.promotion.name.toLowerCase().includes(this.state.search.toLowerCase()))
              )}
              rowKey={(record) => record.id} />
          </Row>
        </div>
      </Affix>
    );
  }
}


// WEBPACK FOOTER //
// ./src/features/admin/events/UserAdd.js